import type { Round } from '@sirius/contracts/admin'
import { useTranslation } from 'react-i18next'
import { Badge } from '~/components/ui/badge'

/** Open while a win is pending or free games are left; closed once settled. */
export function RoundStatusBadge({
  round,
}: {
  round: Pick<Round, 'closedAt'>
}) {
  const { t } = useTranslation()
  return round.closedAt === null ? (
    <Badge>{t('roundsPage.status.open')}</Badge>
  ) : (
    <Badge variant="secondary">{t('roundsPage.status.closed')}</Badge>
  )
}
